"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconVariantMap = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireDefault(require("react"));
const iconVariantMap = {
  "content-library": {
    icon: /*#__PURE__*/_react.default.createElement(_ursaIcons.ContentLibraryColorIcon, {
      size: 20,
      "aria-hidden": "true"
    }),
    color: "" //content-library variants for FileTreeItem don't offer a simplified icon version, so 'color' is not needed
  },

  collection: {
    icon: /*#__PURE__*/_react.default.createElement(_ursaIcons.CollectionMultiColorIcon, {
      size: 20
    }),
    color: "" //collection variants for FileTreeItem don't offer a simplified icon version, so 'color' is not needed
  },

  "collection-item": {
    icon: /*#__PURE__*/_react.default.createElement(_ursaIcons.CollectionSingleColorIcon, {
      size: 20
    }),
    color: (0, _designTokensReact.color)("color--background--spectrum-yellow--weaker")
  },
  dashboard: {
    icon: /*#__PURE__*/_react.default.createElement(_ursaIcons.DashboardsColorIcon, {
      size: 20,
      "aria-hidden": "true"
    }),
    color: (0, _designTokensReact.color)("color--background--spectrum-green--weak", _designTokens.ursaColors.green400)
  },
  file: {
    icon: /*#__PURE__*/_react.default.createElement(_ursaIcons.FilesIcon, {
      size: 20,
      "aria-hidden": "true",
      backgroundColor: (0, _designTokensReact.color)("color--icons--neutral--weakest"),
      color: (0, _designTokensReact.color)("color--icons--neutral--strong")
    }),
    color: "" //file variants for FileTreeItem don't offer a simplified icon version, so 'color' is not needed
  },

  form: {
    icon: /*#__PURE__*/_react.default.createElement(_ursaIcons.FormsColorIcon, {
      size: 20,
      "aria-hidden": "true"
    }),
    color: (0, _designTokensReact.color)("color--background--spectrum-pink--weak", _designTokens.ursaColors.pink200)
  },
  folder: {
    icon: /*#__PURE__*/_react.default.createElement(_ursaIcons.FolderColorIcon, {
      size: 20,
      "aria-hidden": "true"
    }),
    color: "" //folder variants for FileTreeItem don't offer a simplified icon version, so 'color' is not needed
  },

  report: {
    icon: /*#__PURE__*/_react.default.createElement(_ursaIcons.ReportsColorIcon, {
      size: 20,
      "aria-hidden": "true"
    }),
    color: (0, _designTokensReact.color)("color--background--spectrum-orange--weak", _designTokens.ursaColors.orange100)
  },
  sheet: {
    icon: /*#__PURE__*/_react.default.createElement(_ursaIcons.SheetColorIcon, {
      size: 20,
      "aria-hidden": "true"
    }),
    color: (0, _designTokensReact.color)("color--background--spectrum-violet--default", _designTokens.ursaColors.violet300)
  }
};
exports.iconVariantMap = iconVariantMap;
//# sourceMappingURL=constants.js.map